/* Judge.me only serves 70x70 / 140x140 thumbnails of the reviewed products.
   They are shown much bigger on the homepage carousel, so ask Shopify's CDN
   for a 400x400 version of the same file instead. */
(function () {
  var root = document.querySelector('[id$="__judgeme_reviews_home"]');
  if (!root) return;

  var SIZE_PATTERN = /_\d+x\d+(\.\w+)(\?|$)/;

  function upsize(img) {
    ['src', 'data-src', 'data-src-retina'].forEach(function (attr) {
      var value = img.getAttribute(attr);
      if (value && SIZE_PATTERN.test(value)) {
        img.setAttribute(attr, value.replace(SIZE_PATTERN, '_400x400$1$2'));
      }
    });
  }

  function run() {
    root.querySelectorAll('.jdgm-carousel-item__product-image').forEach(upsize);
  }

  run();
  new MutationObserver(run).observe(root, { childList: true, subtree: true });
})();
